/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionCheckIcon20Light = forwardRef('TextActionCheckIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M3.5 8a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" }),
        React.createElement("path", { d: "M3.5 12a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z" }),
        React.createElement("path", { d: "m15.392 16.878 4.024-4.024a.5.5 0 0 0-.707-.708l-4.025 4.025a.438.438 0 0 1-.618 0l-1.837-1.837a.5.5 0 0 0-.708.707l1.837 1.837a1.438 1.438 0 0 0 2.034 0Z" })));
});
